import { useMutation } from '@tanstack/react-query';
import { disManager } from '@m43/core';
import { electronBridge } from '../electron-bridge/electron-bridge';
import { normalize, DexMetadataNormalized } from './get-dex-metadata';

export function useFetchDexMetadata() {
    const mutation = useMutation(
        async (): Promise<DexMetadataNormalized> => {
            if (electronBridge) {
                const data = await electronBridge.getDexMetadata();
                return normalize(data);
            }
            const disManagerResponse = await disManager.getMetadata();
            return normalize(disManagerResponse?.data);
        }
    );

    return mutation.mutateAsync;
}
